<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  
}
</script>

<style lang="less">
	body{
		padding: 0;
		margin: 0;
	}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 1080px;
  height: 1920px;
  position: relative;
  background: url(assets/pagebg.png) center 0 no-repeat;
  margin: 0 auto;
}
</style>
